import React from "react";
// UI Frameworks
import { toast } from "react-toastify";
// Common Components
import { Button, Form, TextInput } from "src/Components";
// Utilities
import { packetErrorHandler } from "src/Utils/requestUtils";
import { MytoLocaleString } from "src/helper";
// Requests
import { triggerGoldPosition } from "src/Requests/goldArbitrage";
// Types
import { GoldPositionTableReport } from "src/Interfaces/goldArbitrage";

interface IProps {
  row: GoldPositionTableReport;
  onClose: () => void;
  onSuccess: () => void;
}

// حداقل ارزش مجاز ارسال مبدا (تومان)
const MIN_SRC_VALUE = 500000;

const SendManualModal = ({ row, onClose, onSuccess }: IProps) => {
  const [loading, setLoading] = React.useState(false);
  // حداکثر ارزش ارسال مبدا: به صورت پیش‌فرض همان مقدار جدول ولی قابل ویرایش
  const [maxSrcValue, setMaxSrcValue] = React.useState<string>(
    row.totalExeSrcValue?.toString() ?? "",
  );

  const numericMaxSrcValue = Number(maxSrcValue);

  // حجم نهایی محاسبه‌شده برای ارسال (وابسته به حداکثر ارزش ارسال مبدا)
  // min(req.srcVolume, floor(maxSrcValue / bidPrice))
  const finalVolume = React.useMemo(() => {
    const fromValue = row.bidPrice
      ? Math.floor(numericMaxSrcValue / row.bidPrice)
      : 0;
    return Math.min(row.req.srcVolume ?? 0, fromValue);
  }, [numericMaxSrcValue, row.bidPrice, row.req.srcVolume]);

  // اعتبارسنجی: maxSrcValue باید بین حداقل مجاز و totalExeSrcValue باشد
  const isInvalid =
    maxSrcValue === "" ||
    numericMaxSrcValue < MIN_SRC_VALUE ||
    numericMaxSrcValue > row.totalExeSrcValue;

  const submitHandler = () => {
    if (isInvalid) return;
    setLoading(true);
    triggerGoldPosition({
      srcIns: row.req.srcIns,
      destIns: row.req.destIns,
      userId: row.req.userId,
      minBubble: row.req.minBubble,
      srcVolume: finalVolume,
    })
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          onSuccess();
          onClose();
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <Form className="p-4 gap-4 !w-72">
      <div className="text-sm font-bold w-full text-right">ارسال دستی</div>
      <TextInput
        label="حداکثر ارزش ارسال مبدا"
        name="maxSrcValue"
        value={maxSrcValue}
        onChange={(_name, value) => setMaxSrcValue(value)}
        kind="priceWithDecimal"
        extraLabel
        endIcon={<span className="text-xs text-gray-500">تومان</span>}
      />
      {isInvalid ? (
        <div className="text-[10px] text-red-500 w-full text-right -mt-3">
          مقدار باید بین {MytoLocaleString(MIN_SRC_VALUE)} و{" "}
          {MytoLocaleString(row.totalExeSrcValue)} تومان باشد
        </div>
      ) : (
        <></>
      )}
      <TextInput
        label="حجم دارایی روی اکانت مبدا"
        name="srcBalance"
        value={row.srcBalance?.toString()}
        onChange={() => {}}
        kind="priceWithDecimal"
        extraLabel
        disabled
      />
      <TextInput
        label="حجم نهایی محاسبه‌شده برای ارسال"
        name="finalVolume"
        value={finalVolume.toString()}
        onChange={() => {}}
        kind="number"
        extraLabel
        disabled
      />
      <Button
        text="تایید و ارسال"
        variant="contained"
        onClick={submitHandler}
        loading={loading}
        disabled={isInvalid}
      />
    </Form>
  );
};

export default SendManualModal;
